export const addToSet = <T>(set: T[] | undefined, item: T) => {
  if (!set) return [item];
  if (set.includes(item)) return set;
  return [...set, item];
};

export const removeFromSet = <T>(set: T[] | undefined, item: T) => {
  if (!set) return [];
  return set.filter((i) => i !== item);
};
